import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface Logout extends SVGProps<SVGSVGElement> {
  label?: string
}

const Logout: React.FC<Logout> = ({ label = 'logout', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="logout-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 8C11 8.55228 10.5523 9 10 9C9.44774 9 9.00003 8.55228 9.00003 8V6C9.00003 4.89543 9.89546 4 11 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H11C9.89546 20 9.00003 19.1046 9.00003 18V16C9.00003 15.4477 9.44774 15 10 15C10.5523 15 11 15.4477 11 16V17.5C11 17.7761 11.2239 18 11.5 18H19.5C19.7762 18 20 17.7761 20 17.5V6.5C20 6.22386 19.7762 6 19.5 6H11.5C11.2239 6 11 6.22386 11 6.5V8Z"
          fill="currentColor"
        />
        <path
          d="M12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H5.41424L6.70714 14.2929C7.09766 14.6834 7.09766 15.3166 6.70714 15.7071C6.31661 16.0976 5.68345 16.0976 5.29292 15.7071L1.58582 12L5.29292 8.29289C5.68345 7.90237 6.31661 7.90237 6.70714 8.29289C7.09766 8.68342 7.09766 9.31658 6.70714 9.70711L5.41424 11H12Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default Logout
